import React, { useContext, useEffect } from 'react'
import { Autocomplete, TextField } from '@mui/material'
import { GlobalContext } from '../App'

// Picks the base location(s) a new employee belongs to. Every employee
// account needs at least one (the server refuses to create one without,
// unless the tenant has exactly one base), so a lone base is pre-selected.
// `value` and `onChange` work in base location ids.
const EmployeeBaseLocationsSelect = ({
  value = [],
  onChange,
  label = 'Base Locations',
  helperText = 'The base location(s) this employee works from',
  error = false,
  ...props
}) => {
  const { baseLocationOptions: options = [] } = useContext(GlobalContext)
  const selectedIds = value.map(String)
  const selected = options.filter((option) =>
    selectedIds.includes(String(option._id)),
  )

  useEffect(() => {
    if (options.length === 1 && !value.length) onChange([options[0]._id])
  }, [options])

  return (
    <Autocomplete
      multiple
      fullWidth
      value={selected}
      options={options}
      onChange={(e, newValue) => onChange(newValue.map((option) => option._id))}
      isOptionEqualToValue={(a, b) => String(a?._id) === String(b?._id)}
      getOptionLabel={(option) => option?.name ?? ''}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          required={!selected.length}
          error={error}
          helperText={helperText}
        />
      )}
      {...props}
    />
  )
}

export default EmployeeBaseLocationsSelect
